const initialState = {
  body: ''
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_NEW_COMMENT_BODY': {
      return { ...state, body: action.payload };
    }
    case 'ADDING_NEW_COMMETN_SUCCEED': {
      return { ...state, body: '' };
    }
    default:
      return state;
  }
}
